import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { demoLightDare } from "../demoLightDare/demoLightDareAPI";

const initialState = {
    status: "idle",
    NewQuestion:'',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories:[],
    UsedQuestionsId:[],
    LastCard: false,
}

export const demoLightDareAsync = createAsyncThunk(
    "/demolightdare",
    async ({gender, player}, {getState, rejectWithValue }) => {
        try {
            const state = getState()
            const usedid = state.demoLightDare.UsedQuestionsId
            const selectedaccessories = state.demoLightDare.Accessories
            const sessionid = state.gameStatus.sessions['demo'].sessionId


        
            const response = await demoLightDare(gender, player, usedid, selectedaccessories, sessionid);
            return response
        } catch (error) {
        console.error("Error in demoLightDareAsync:", error); // 👀 This should appear now
        return rejectWithValue(error.response
            ? { data: error.response.data, status: error.response.status }
            : { data: { error: "Unknown error" }, status: 500 })
    }
    }
)

export const demoLightDareSlice = createSlice({
    name: "demolightdare",
    initialState,
    reducers: {
        setAccessories: (state, action) =>{
            state.Accessories = action.payload

        },
        resetState:(state) =>{
            state.status ="idle"
            state.NewQuestion = ''
            state.NewQuestionTimer = ''
            state.DrinkQuestion = ''
            state.Attributes = []
            state.Accessories = []
            state.UsedQuestionsId =[]
            state.LastCard = false;
        },
    },
    extraReducers:(builder) => {
        builder
            .addCase(demoLightDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(demoLightDareAsync.fulfilled, (state, action)=>{
                state.status ="fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId,action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })}})

export const selectDemoLightDare = (state) => state.demoLightDare
export const { setAccessories, resetState } = demoLightDareSlice.actions;
export default demoLightDareSlice.reducer